import React, { ReactElement } from 'react'
import { useRouter } from 'next/router'
import routesConfig from '@mindfulchefuk/config/routesConfig'
import { BackLink } from '@mindfulchefuk/design-system'

const RecipeDetailsBackButton = ({
  deliveryDate,
}: {
  deliveryDate?: string
}): ReactElement => {
  const router = useRouter()
  const { recipeSlug, ...recipesParams } = router.query

  const href = deliveryDate
    ? routesConfig.deliveryDetails.pathname(deliveryDate)
    : {
        pathname: routesConfig.recipes.pathname,
        query: recipesParams,
      }

  return (
    <BackLink href={href}>{`Back to ${
      deliveryDate ? 'my delivery' : 'recipes'
    }`}</BackLink>
  )
}

export default RecipeDetailsBackButton
